import React, { Component } from 'react';
import ReactExport from "react-export-excel";
import Moment from 'moment';
import axios from 'axios';
import {API_URL} from '../../../constants';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class EncuestaExcel extends Component {
    constructor(props)
    {
        super(props);
    }

    props = {
        dataReport: []
      }

    render() {
        return (
            <ExcelFile filename="ENCUESTA" element={<a href="#" className="btnReporte_Log">REPORTE</a>}>
                <ExcelSheet data={this.props.dataReport} name="ENCUESTA">
                    <ExcelColumn label="NOMBRES" value="enc_Nombres"/>
                    <ExcelColumn label="APELLIDOS" value="enc_Apellidos"/>                    
                    <ExcelColumn label="CORREO ELECTRÓNICO" value="enc_CorreoElectronico"/>   
                    <ExcelColumn label="TELÉFONO" value="enc_Telefono"/>   
                    <ExcelColumn label="RESPUESTA 1" value="enc_Respuesta1"/>   
                    <ExcelColumn label="RESPUESTA 2" value="enc_Respuesta2"/>   
                    <ExcelColumn label="FECHA DE REGISTRO" value={(col) => Moment(col.enc_FechaRegistro).format('DD/MM/YYYY')}/>                        
                </ExcelSheet>
            </ExcelFile>
        )
    }
}
